<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Perfect Bunch</h1>
<p class="BOD2">These hot-house flower heads look great bunched together as a striking scarf trim.</p>
<p class="IMAGE"><img alt="" src="images/C1-17.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-18.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-9.vue?b3c8760c